import script from "./AddOrEditNoteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddOrEditNoteModal.vue?vue&type=script&setup=true&lang=js"

import "./AddOrEditNoteModal.vue?vue&type=style&index=0&id=ff38f008&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff38f008"]])

export default __exports__